import { useMemo, useState } from "react";
import { films, genres } from "@/mocks/films";
import PosterCard from "@/pages/home/components/PosterCard";

export default function LibraryGrid() {
  const [active, setActive] = useState("All");

  const filtered = useMemo(
    () =>
      active === "All"
        ? films
        : films.filter((f) => f.genres.includes(active)),
    [active],
  );

  return (
    <section id="library" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 font-label text-[11px] tracking-[0.3em] uppercase text-primary-500">
              <span className="w-6 h-px bg-primary-500" />
              Browse the Catalogue
            </span>
            <h2 className="mt-3 font-heading font-extrabold uppercase tracking-tight text-foreground-950 text-3xl md:text-5xl">
              The Library
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
              Explore titles across action, thriller, romance, comedy and beyond.
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {genres.map((genre) => (
            <button
              key={genre}
              type="button"
              onClick={() => setActive(genre)}
              className={`rounded-full px-4 py-2 font-label text-xs tracking-[0.14em] uppercase whitespace-nowrap transition-colors cursor-pointer ${
                active === genre
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {genre}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5 md:gap-6">
          {filtered.map((film) => (
            <PosterCard key={film.id} film={film} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="mt-12 text-center py-14 rounded-lg bg-background-100">
            <i className="ri-film-line text-4xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-600">No titles in this genre yet.</p>
          </div>
        )}
      </div>
    </section>
  );
}